var _clipPath, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAltCaffeine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "105.82mm",
    height: "122mm",
    viewBox: "0 0 105.82 122",
    xmlSpace: "preserve",
    id: "svg100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs104"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7144"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffadad",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop7142"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7130"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffadad",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop7128"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "Clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L161 0 L161 101 L0 101 L0 0 Z",
    transform: "translate(0, 0)",
    id: "path10494"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    d: "M0,3.8L0,3.8L0,3.8L0,3.8L0,3.8z M434,224.2 M0,3.8"
  }))), /*#__PURE__*/React.createElement("rect", {
    style: {
      mixBlendMode: "multiply",
      fill: "#ff8e8e",
      fillOpacity: 0,
      fillRule: "evenodd",
      stroke: "#840000",
      strokeWidth: 1.464,
      strokeLinecap: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.450777
    },
    id: "rect262",
    width: 103.02634,
    height: 118.93182,
    x: 1.3825192,
    y: 1.685971,
    ry: 7.1569595
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1231",
    transform: "matrix(0.26458333,0,0,0.26458333,14.918844,20.642948)",
    style: {
      mixBlendMode: "soft-light",
      stroke: "#ffe851",
      strokeWidth: 5.9149607,
      strokeDasharray: "none",
      strokeOpacity: 0.48704663,
      paintOrder: "stroke markers fill"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.7,
    y: 121.6,
    width: 2.4000001,
    height: 45.599998,
    id: "rect1203",
    style: {
      stroke: "#ffe851",
      strokeWidth: 5.9149607,
      strokeDasharray: "none",
      strokeOpacity: 0.48704663,
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.400002,
    y: 77.199997,
    transform: "matrix(0.5004,-0.8658,0.8658,0.5004,-61.2454,86.7775)",
    width: 2.4000001,
    height: 38.5,
    id: "rect1205",
    style: {
      stroke: "#ffe851",
      strokeWidth: 5.91493172,
      strokeDasharray: "none",
      strokeOpacity: 0.48704663,
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.5,
    y: 222.3,
    width: 2.4000001,
    height: 37.400002,
    id: "rect1207",
    style: {
      stroke: "#ffe851",
      strokeWidth: 5.9149607,
      strokeDasharray: "none",
      strokeOpacity: 0.48704663,
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264,143.5 264,143.5 264.4,144 264.7,144.4 245.9,170.3 247.8,171.7 266,146.7 266,146.7 266,146.6 267.1,145.1 267.7,144.4 267.1,143.7 266.5,142.8 266,142.1 247.1,116.1 245.2,117.5 ",
    id: "polygon1209",
    style: {
      stroke: "#ffe851",
      strokeWidth: 5.9149607,
      strokeDasharray: "none",
      strokeOpacity: 0.48704663,
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.89999,
    y: 152.89999,
    transform: "matrix(0.5876,-0.8091,0.8091,0.5876,-23.0624,262.8658)",
    width: 26.9,
    height: 2.4000001,
    id: "rect1211",
    style: {
      stroke: "#ffe851",
      strokeWidth: 5.91520746,
      strokeDasharray: "none",
      strokeOpacity: 0.48704663,
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.7,87.7 123.7,50.2 121.3,50.2 121.3,89.1 93.7,105.1 94.9,107.1 126.5,88.9 126.5,88.9 127.7,88.2 128.8,88.9 128.8,88.8 176.3,116.3 176.3,172.5 143.6,191.5 144.8,193.5 177.7,174.5 214.9,186.6 215.6,184.3 178.7,172.3 178.7,116.5 215.6,104.5 214.9,102.2 177.7,114.3 134,89.1 134,50.2 131.7,50.2 131.7,87.7 128.5,85.9 127.7,85.4 126.8,85.9 ",
    id: "polygon1213",
    style: {
      stroke: "#ffe851",
      strokeWidth: 5.9149607,
      strokeDasharray: "none",
      strokeOpacity: 0.48704663,
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.8,
    y: 58.799999,
    transform: "matrix(0.3094,-0.9509,0.9509,0.3094,111.8973,274.0325)",
    width: 35.700001,
    height: 2.4000001,
    id: "rect1215",
    style: {
      stroke: "#ffe851",
      strokeWidth: 5.91514062,
      strokeDasharray: "none",
      strokeOpacity: 0.48704663,
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.8,100.8 66.8,129.5 70.4,129.5 70.4,107.1 70.5,107.1 84.9,129.5 88.7,129.5 88.7,100.8 85.1,100.8 85.1,123.1 70.7,100.8 ",
    id: "polygon1217",
    style: {
      stroke: "#ffe851",
      strokeWidth: 5.9149607,
      strokeDasharray: "none",
      strokeOpacity: 0.48704663,
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.6,173.9 78.9,175.3 78.9,175.3 80.6,176.2 47.8,195.1 49,197.2 83,177.6 110.5,193.5 111.7,191.5 79,172.5 79,171.2 79,135.9 76.6,135.9 76.6,166.5 42.6,186.1 43.9,188.2 76.6,169.3 76.6,171.2 76.6,173.2 ",
    id: "polygon1219",
    style: {
      stroke: "#ffe851",
      strokeWidth: 5.9149607,
      strokeDasharray: "none",
      strokeOpacity: 0.48704663,
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.6,215.9 138.6,187.2 135.1,187.2 135.1,209.5 135,209.5 120.6,187.2 116.7,187.2 116.7,215.9 120.3,215.9 120.3,193.5 134.7,215.9 ",
    id: "polygon1221",
    style: {
      stroke: "#ffe851",
      strokeWidth: 5.9149607,
      strokeDasharray: "none",
      strokeOpacity: 0.48704663,
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 34.9,188.8 c -3.1,-1.8 -7,-1.8 -7,-1.8 -3.9,0 -7,1.8 -7,1.8 -3.2,1.8 -4.9,5.2 -4.9,5.2 -1.8,3.4 -1.8,7.8 -1.8,7.8 0,4.3 1.8,7.7 1.8,7.7 1.8,3.4 4.9,5.2 4.9,5.2 3.1,1.8 7.1,1.8 7.1,1.8 3.9,0 7,-1.8 7,-1.8 3.1,-1.8 4.9,-5.2 4.9,-5.2 1.8,-3.4 1.8,-7.8 1.8,-7.8 0,-4.5 -1.8,-7.8 -1.8,-7.8 -1.8,-3.3 -5,-5.1 -5,-5.1 z m 1.5,19.2 c -1.2,2.6 -3.5,4 -3.5,4 -2.2,1.4 -5,1.4 -5,1.4 -2.8,0 -5.1,-1.4 -5.1,-1.4 -2.2,-1.4 -3.4,-4 -3.4,-4 -1.3,-2.6 -1.3,-6.1 -1.3,-6.1 0,-3.6 1.2,-6.3 1.2,-6.3 1.2,-2.6 3.4,-4 3.4,-4 2.2,-1.4 5.1,-1.4 5.1,-1.4 2.9,0 5.1,1.4 5.1,1.4 2.2,1.4 3.4,4 3.4,4 1.2,2.6 1.2,6.2 1.2,6.2 0.2,3.6 -1.1,6.2 -1.1,6.2 z",
    id: "path1223",
    style: {
      stroke: "#ffe851",
      strokeWidth: 5.9149607,
      strokeDasharray: "none",
      strokeOpacity: 0.48704663,
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 120.6,41.9 c 3.2,1.8 7.1,1.8 7.1,1.8 3.9,0 7,-1.8 7,-1.8 3.1,-1.8 4.9,-5.2 4.9,-5.2 1.8,-3.4 1.8,-7.8 1.8,-7.8 0,-4.5 -1.8,-7.8 -1.8,-7.8 -1.8,-3.3 -4.9,-5.2 -4.9,-5.2 -3.1,-1.8 -7,-1.8 -7,-1.8 -3.9,0 -7,1.8 -7,1.8 -3.2,1.8 -4.9,5.2 -4.9,5.2 -1.8,3.4 -1.8,7.8 -1.8,7.8 0,4.3 1.8,7.7 1.8,7.7 1.7,3.5 4.8,5.3 4.8,5.3 z m -1.5,-19.1 c 1.2,-2.6 3.5,-4 3.5,-4 2.2,-1.4 5.1,-1.4 5.1,-1.4 2.9,0 5.1,1.4 5.1,1.4 2.2,1.4 3.5,4 3.5,4 1.2,2.6 1.2,6.2 1.2,6.2 0,3.6 -1.2,6.2 -1.2,6.2 -1.2,2.6 -3.5,4 -3.5,4 -2.2,1.4 -5,1.4 -5,1.4 -2.8,0 -5,-1.4 -5,-1.4 -2.2,-1.4 -3.5,-4 -3.5,-4 -1.2,-2.6 -1.2,-6.1 -1.2,-6.1 -0.2,-3.6 1,-6.3 1,-6.3 z",
    id: "path1225",
    style: {
      stroke: "#ffe851",
      strokeWidth: 5.9149607,
      strokeDasharray: "none",
      strokeOpacity: 0.48704663,
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.3,204.9 243.3,176.2 239.7,176.2 239.7,198.5 239.6,198.5 225.3,176.2 221.3,176.2 221.3,204.9 224.9,204.9 224.9,182.5 225,182.5 239.4,204.9 ",
    id: "polygon1227",
    style: {
      stroke: "#ffe851",
      strokeWidth: 5.9149607,
      strokeDasharray: "none",
      strokeOpacity: 0.48704663,
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.3,83 221.3,111.7 224.9,111.7 224.9,89.3 225,89.3 239.4,111.7 243.3,111.7 243.3,83 239.7,83 239.7,105.3 239.6,105.3 225.3,83 ",
    id: "polygon1229",
    style: {
      stroke: "#ffe851",
      strokeWidth: 5.9149607,
      strokeDasharray: "none",
      strokeOpacity: 0.48704663,
      paintOrder: "stroke markers fill"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltCaffeine);
export default __webpack_public_path__ + "static/media/altCaffeine.8d148e338fba47451ea4e9d7feb3cc1e.svg";
export { ForwardRef as ReactComponent };